export default function translate(i18n, propriete) {
  if (propriete.indexOf('Sens') !== -1) return i18n.t('addEditTypeFormatPresse.error.sens');
  if (propriete.indexOf('SurfaceId') !== -1) return i18n.t('addEditTypeFormatPresse.error.surface');
  if (propriete.indexOf('EmplacementId') !== -1) return i18n.t('addEditTypeFormatPresse.error.emplacement');
  if (propriete.indexOf('CouleurEncartId') !== -1) return i18n.t('addEditTypeFormatPresse.error.couleur');
  if (propriete.indexOf('Hauteur') !== -1) return i18n.t('addEditTypeFormatPresse.error.hauteur');
  if (propriete.indexOf('Largeur') !== -1) return i18n.t('addEditTypeFormatPresse.error.largeur');
  if (propriete === 'code') return i18n.t('addEditTypeFormatPresse.error.code');
  return propriete;
}
